import React, { useState, useEffect, useRef } from "react";

import { Bar, getElementAtEvent } from "react-chartjs-2";
import { useTranslation } from "react-i18next";
import ReportsDiamondService from "../../services/reports-Diamond.service";
import GlobalDiamondReportService from "../../services/reports-globalDiamond-service";
import logoImg from "../../assets/images/logo-img.png";
import { useSelector } from "react-redux";
import moment from "moment";
import { BlobToDownloadFile } from "../../helper/commanFunction";
import { Button, DatePicker, Select, Spin, Table, Tooltip } from "antd";
import Chart from "react-google-charts";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { chartColors } from "../reports/colors";

const { RangePicker } = DatePicker;
const { Option } = Select;

const DiamondCutIndComp = () => {
  const { t } = useTranslation();
  const DiamondCutChartRef = useRef();
  /*Initial State for Binding Starts*/
  const initialGlobalDiamondState = {
    dataRangeFrom: moment().subtract(30, "days").format("YYYY-MM-DD"),
    dataRangeTo: moment().format("YYYY-MM-DD"),
    SelectedDiamondValue: "All",
    retailerIds: [],
    vendorIds: [],
  };
  /*Initial State for Binding Ends*/

  /*React Binding Starts*/
  const [TableForAllList, setTableForAllList] = useState([]);
  const [globalDiamonds, setGlobalDiamond] = useState(
    initialGlobalDiamondState
  );
  const [tableKey, setTableKey] = useState(true);
  const [LoadChartReportsLoading, setLoadChartReportsLoading] = useState(false);
  const [TableForAllLoading, setTableForAllLoading] = useState(false);
  const [TotalDiamondClicks, setTotalDiamondClicks] = useState(0);
  const [dealerId, setDealerId] = useState();
  const [forDealer, setForDealer] = useState("");
  const loginDetials = useSelector((state) => state.loginReducer);
  const [diamondCutGradeSearchesLabels, setdiamondCutGradeSearchesLabels] =
    useState([]);
  const [DiamondCutGradeSearchesList, setDiamondCutGradeSearchesList] =
    useState([]);
  const [DiamondCutGradeColorData, setDiamondCutGradeColorData] = useState([]);
  const [DiamondCutGradeYAxisList, setDiamondCutGradeYAxisList] = useState([]);
  const [TableShapeValue, setTableShapeValue] = useState("");
  const [TableClarityValue, setTableClarityValue] = useState("");
  const [TableCutGradeValue, setTableCutGradeValue] = useState("");
  const [TableColorValue, setTableColorValue] = useState("");
  const [TableSizeValue, setTableSizeValue] = useState("");
  const [TableCertificateValue, setTableCertificateValue] = useState("");
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(15);
  const [totalCount, setTotalCount] = useState(0);
  const [sortType, setSortType] = useState("desc");
  const [sortColumnName, setSortColumnName] = useState("GT.MODIFIED");
  const [key, setKey] = useState(true);
  const [downloadCSVDataloading, setDownloadCSVDataloading] = useState(false);
  const [downloadPDFDataloading, setDownloadPDFDataloading] = useState(false);

  // New state for custom legends and max entries
  const [chartData, setChartData] = useState([]);
  const [colorData, setColorData] = useState([]);
  const [processedCutLabels, setProcessedCutLabels] = useState([]);
  const [processedCutCounts, setProcessedCutCounts] = useState([]);

  // Configuration
  const MAX_ENTRIES = 15; // Maximum bars to show

  /*React Binding Ends*/

  useEffect(() => {
    if (loginDetials) {
      if (loginDetials.loginDetials) {
        if (loginDetials.loginDetials.responseData.logInSucceeded) {
          setDealerId(loginDetials.loginDetials.responseData.dealerId);
          handleCheckDealermembers(
            loginDetials.loginDetials.responseData.dealerId
          );
        }
      }
    }
  }, []);

  useEffect(() => {
    if (TableCutGradeValue) {
      setTableKey(!tableKey);
      setPageSize(15);
      handleGetDiamondReportForTableChartAll(dealerId, forDealer);
    }
  }, [TableCutGradeValue]);

  // Process chart data with max entries limit for bar chart
  const processChartData = (cutGrades, counts) => {
    if (!cutGrades?.length || !counts?.length || cutGrades.length !== counts.length) {
      return { chartData: [], colors: [], processedLabels: [], processedCounts: [] };
    }

    // Combine cut grades and counts into objects
    const combinedData = cutGrades.map((cutGrade, index) => ({
      cutGrade,
      count: counts[index],
      originalIndex: index
    }));

    // Filter out zero values and sort by count (descending)
    const filteredData = combinedData.filter(item => item.count > 0);
    const sortedData = [...filteredData].sort((a, b) => b.count - a.count);

    // Apply max entries limit
    const topData = sortedData.slice(0, MAX_ENTRIES);
    const remainingData = sortedData.slice(MAX_ENTRIES);

    // Calculate "Others" if needed
    const othersValue = remainingData.reduce((sum, item) => sum + item.count, 0);
    if (othersValue > 0 && remainingData.length > 0) {
      topData.push({
        cutGrade: t("Others"),
        count: othersValue,
        isOthers: true
      });
    }

    // Prepare chart data
    const processedChartData = [["Cut Grade", "Count", { role: "style" }, { role: "annotation" }]];
    const colors = [];
    const processedLabels = [];
    const processedCounts = [];

    topData.forEach((item, index) => {
      const color = chartColors[index % chartColors.length];
      colors.push(color);
      
      // For Google Charts with style and annotation
      processedChartData.push([item.cutGrade, item.count, color, item.count]);
      
      // Store processed data for other uses
      processedLabels.push(item.cutGrade);
      processedCounts.push(item.count);
    });

    return { 
      chartData: processedChartData, 
      colors, 
      processedLabels, 
      processedCounts 
    };
  };

  /*API Binding Starts*/
  const handleCheckDealermembers = (id) => {
    let inputData = {
      dealerID: id,
    };
    GlobalDiamondReportService.CheckDealermembers(inputData)
      .then((response) => {
        var message = response.data.message;
        var responseData = response.data.responseData;
        var forDealer = responseData.forDealer;
        if (message === "Success") {
          if (Object.keys(responseData).length !== 0) {
            setForDealer(forDealer);
          } else {
            setForDealer("");
          }
          handleLoadChartReports(id, forDealer);
          handleGetDiamondReportForTableChartAll(
            id,
            forDealer,
            pageNo,
            pageSize,
            sortColumnName,
            sortType
          );
        } else {
          setForDealer("");
        }
      })
      .catch((error) => {
        setForDealer("");
      });
  };

  const handleLoadChartReports = (dealerId, forDealer) => {
    let inputData = {
      dealerID: dealerId.toString(),
      forDealer: forDealer ? forDealer.toString() : "",
      fromDate: globalDiamonds.dataRangeFrom
        ? moment(globalDiamonds.dataRangeFrom).format("YYYY-MM-DD")
        : "2020-08-17",
      toDate: globalDiamonds.dataRangeTo
        ? moment(globalDiamonds.dataRangeTo).format("YYYY-MM-DD")
        : "2022-09-15",
      retailerIds: globalDiamonds.retailerIds.toString(),
      vendorIds: globalDiamonds.vendorIds.toString(),
      selectedDiamondValue: globalDiamonds.SelectedDiamondValue,
      type: "",
      reportName: "CutGrade",
    };
    setLoadChartReportsLoading(true);

    GlobalDiamondReportService.LoadChartReports(inputData)
      .then((response) => {
        var message = response.data.message;
        var responseData = response.data.responseData;
        var DiamondCutGradeSearchesList = responseData.DiamondCutGradeSearches;
        var TotalDiamondClicks =
          responseData.TotalDiamondClicks[0].TotalClickCnt;
        if (message === "Success") {
          if (Object.keys(responseData).length !== 0) {
            setTotalDiamondClicks(TotalDiamondClicks);
            setDiamondCutGradeSearchesList(DiamondCutGradeSearchesList);
            var DiamondCutGradeSearchesLabelArr =
              DiamondCutGradeSearchesList.map((item) => {
                return item.CutGrade;
              });
            setdiamondCutGradeSearchesLabels(DiamondCutGradeSearchesLabelArr);
            var DiamondCutGradeYAxisList = DiamondCutGradeSearchesList.map(
              (item) => {
                return item.CNT;
              }
            );
            var DiamondCutGradeColorList = DiamondCutGradeSearchesList.map(
              (item) => {
                return item.CutGrade;
              }
            );
            setDiamondCutGradeYAxisList(DiamondCutGradeYAxisList);
            
            // Process data with max entries limit
            const { 
              chartData: processedChartData, 
              colors, 
              processedLabels, 
              processedCounts 
            } = processChartData(DiamondCutGradeSearchesLabelArr, DiamondCutGradeYAxisList);
            
            setChartData(processedChartData);
            setColorData(colors);
            setProcessedCutLabels(processedLabels);
            setProcessedCutCounts(processedCounts);
            
            diamondCutGradeColorHandler(DiamondCutGradeColorList);
            setKey(!key);
          }
        } else {
          setTotalDiamondClicks(0);
          setDiamondCutGradeSearchesList([]);
          setDiamondCutGradeYAxisList([]);
          setChartData([]);
          setColorData([]);
        }
      })
      .catch((error) => {
        setTotalDiamondClicks(0);
        setDiamondCutGradeSearchesList([]);
        setDiamondCutGradeYAxisList([]);
        setdiamondCutGradeSearchesLabels([]);
        setChartData([]);
        setColorData([]);
      })
      .finally(() => setLoadChartReportsLoading(false));
  };

  const handleExportToCSV = (sortColumn, sorttype) => {
    try {
      let forDealerValue = "";
      if (
        loginDetials.loginDetials.responseData.dealerMemberTypeName === "Vendor"
      ) {
        forDealerValue = 1;
      } else {
        forDealerValue = 3;
      }
      let inputData = {
        dealerID: dealerId.toString(),
        forDealer: forDealer ? forDealer.toString() : "",
        fromDate: globalDiamonds.dataRangeFrom
          ? moment(globalDiamonds.dataRangeFrom).format("YYYY-MM-DD")
          : "2020-08-17",
        toDate: globalDiamonds.dataRangeTo
          ? moment(globalDiamonds.dataRangeTo).format("YYYY-MM-DD")
          : "2022-09-15",
        clarity: TableClarityValue,
        cutGrade: TableCutGradeValue,
        shape: TableShapeValue,
        color: TableColorValue,
        size: TableSizeValue,
        certificate: TableCertificateValue,
        selectedDiamondValue: globalDiamonds.SelectedDiamondValue,
        pageNumber: pageNo ? pageNo : 1,
        pageSize: pageSize ? pageSize : 15,
        sortOrderCol: sortColumnName || "GT.MODIFIED",
        sortOrderType: "ASC",
        reporttype: "Global",
        reportName: "CutGrade",
      };
      setDownloadCSVDataloading(true);
      ReportsDiamondService.ExportDataToCSV(inputData)
        .then((response) => {
          setDownloadCSVDataloading(false);
          var fileName =
            "Global_DiamondCut_Report_" +
            new Date().toJSON().slice(0, 10).split("-").slice(1).concat(new Date().toJSON().slice(0, 4)).join("_") +
            ".csv";
          BlobToDownloadFile(response.data, fileName);
        })
        .catch((error) => {
          setDownloadCSVDataloading(false);
        });
    } catch (error) {
      setDownloadCSVDataloading(false);
    }
  };

  const handleExportToPDF = () => {
    try {
      let inputData = {
        dealerID: dealerId.toString(),
        forDealer: forDealer ? forDealer.toString() : "",
        fromDate: globalDiamonds.dataRangeFrom
          ? moment(globalDiamonds.dataRangeFrom).format("YYYY-MM-DD")
          : "2020-08-17",
        toDate: globalDiamonds.dataRangeTo
          ? moment(globalDiamonds.dataRangeTo).format("YYYY-MM-DD")
          : "2022-09-15",
        clarity: TableClarityValue,
        cutGrade: TableCutGradeValue,
        shape: TableShapeValue,
        color: TableColorValue,
        size: TableSizeValue,
        certificate: TableCertificateValue,
        selectedDiamondValue: globalDiamonds.SelectedDiamondValue,
        pageNumber: pageNo ? pageNo : 1,
        pageSize: pageSize ? pageSize : 15,
        sortOrderCol: sortColumnName || "GT.MODIFIED",
        sortOrderType: "ASC",
        reporttype: "Global",
        reportName: "CutGrade",
      };
      setDownloadPDFDataloading(true);
      ReportsDiamondService.ExportDataToPDF(inputData)
        .then((response) => {
          setDownloadPDFDataloading(false);
          var fileName =
            "Global_DiamondCut_Report_" +
            new Date().toJSON().slice(0, 10).split("-").slice(1).concat(new Date().toJSON().slice(0, 4)).join("_") +
            ".pdf";
          BlobToDownloadFile(response.data, fileName, "pdf");
        })
        .catch((error) => {
          setDownloadPDFDataloading(false);
        });
    } catch (error) {
      setDownloadPDFDataloading(false);
    }
  };

  const handleGetDiamondReportForTableChartAll = (
    dealerId,
    forDealer,
    pageNo,
    pageSize,
    sortColumnName,
    sortOrder,
    cutGradeName
  ) => {
    let inputData = {
      dealerID: dealerId.toString(),
      forDealer: forDealer ? forDealer.toString() : "",
      fromDate: globalDiamonds.dataRangeFrom
        ? moment(globalDiamonds.dataRangeFrom).format("YYYY-MM-DD")
        : "2020-08-17",
      toDate: globalDiamonds.dataRangeTo
        ? moment(globalDiamonds.dataRangeTo).format("YYYY-MM-DD")
        : "2022-09-15",
      clarity: TableClarityValue,
      cutGrade: cutGradeName ? cutGradeName : TableCutGradeValue,
      shape: TableShapeValue,
      color: TableColorValue,
      size: TableSizeValue,
      certificate: TableCertificateValue,
      selectedDiamondValue: globalDiamonds.SelectedDiamondValue,
      pageNumber: pageNo ? pageNo : 1,
      pageSize: pageSize ? pageSize : 15,
      sortOrderCol: sortColumnName || "GT.MODIFIED",
      sortOrderType: sortOrder || "DESC",
      reporttype: "Global",
      reportName: "CutGrade",
    };
    setTableForAllLoading(true);

    ReportsDiamondService.GetDiamondReportForTableChartAll(inputData)
      .then((response) => {
        var message = response.data.message;
        var responseData = response.data.responseData;
        var TableForAllList = responseData.modelTableChartAllList;
        var TotalEventsCount = responseData.totalCount;
        if (message === "Success") {
          if (
            responseData?.modelTableChartAllList &&
            responseData?.modelTableChartAllList !== null
          ) {
            if (Object.keys(responseData).length !== 0) {
              setTotalCount(TotalEventsCount);
              setTableForAllList(TableForAllList);
            }
          } else {
            setTotalCount(0);
            setTableForAllList([]);
          }
        } else {
          setTotalCount(0);
          setTableForAllList([]);
        }
      })
      .catch((error) => {
        setTotalCount(0);
        setTableForAllList([]);
        setTableForAllLoading(false);
      })
      .finally(() => setTableForAllLoading(false));
  };
  const handleTableASCDES = (pagination, filters, sorter) => {
    var tableBody = document.querySelector(".pendjewelreq__tbl .ant-table-body"); if (tableBody) tableBody.scrollTop = 0;
    var type = "";
    var column = "";
    //sorting
    if (sorter.order == "descend") {
      type = "DESC";
      column = sorter.field;
      setSortType(type);
      setSortColumnName(column);
    } else if (sorter.order == "ascend") {
      type = "ASC";
      column = sorter.field;
      setSortType(type);
      setSortColumnName(column);
    } else {
      type = "DESC";
      column = "GT.MODIFIED";
      setSortColumnName(column);
      setSortType(type);
    }
    setPageNo(pagination.current);
    setPageSize(pagination.pageSize);
    handleGetDiamondReportForTableChartAll(
      dealerId,
      forDealer,
      pagination.current,
      pagination.pageSize,
      column,
      type
    );
  };
  /*API Binding Ends*/
  const diamondCutGradeColorHandler = (list) => {
    const colors = list.map(
      (_, index) => chartColors[index % chartColors.length]
    );
    setDiamondCutGradeColorData(colors);
  };
  /*DatePicker Binding Starts*/
  const onDateChange = (dates, dateStrings) => {
    if (dates) {
      setGlobalDiamond((prevState) => ({
        ...prevState,
        dataRangeFrom: dateStrings[0],
        dataRangeTo: dateStrings[1],
      }));
    }
  };
  /*DatePicker Binding Ends*/

  const handleOnChange = (e, isSelect, name) => {
    setGlobalDiamond({
      ...globalDiamonds,
      [name]: e,
    });
  };

  const handleApplyFilter = () => {
    setTableKey(!tableKey);
    setPageSize(15);
    setTableCutGradeValue("");
    handleLoadChartReports(dealerId, forDealer);
    handleGetDiamondReportForTableChartAll(
      dealerId,
      forDealer,
      1,
      10,
      "GT.MODIFIED",
      "DESC",
      ""
    );
  };

  const chartOptions = {
    legend: { position: "none" },
    bar: { groupWidth: "40%" },
    chartArea: { left: 40, top: 80, bottom: 70, width: "90%", height: "80%" },
    hAxis: {
      title: "Cut Grade",
      textStyle: { fontSize: 18, bold: true, color: "#424242" },
      titleTextStyle: { color: "rgb(66, 66, 66)", fontSize: 22, bold: true },
      slantedText: true,
      slantedTextAngle: 45,
    },
    vAxis: {
      title: "Count",
      textStyle: { fontSize: 18, bold: true, color: "#424242" },
      titleTextStyle: { color: "rgb(66, 66, 66)", fontSize: 22, bold: true },
    },
    annotations: {
      alwaysOutside: true,
      textStyle: {
        fontSize: 16,
        bold: true,
        color: "#000",
      },
    },
  };

  const handleClick = ({ chartWrapper }) => {
    const chart = chartWrapper.getChart();
    const selection = chart.getSelection();
    if (selection.length > 0) {
      const selectedItem = selection[0];
      const label = chartData[selectedItem.row + 1][0];
      
      // Handle "Others" selection
      if (label === t("Others")) {
        // You might want to handle "Others" selection differently
        // For now, let's clear the cut grade filter when "Others" is selected
        setTableCutGradeValue("");
        return;
      }
      
      setTableCutGradeValue(label);
    }
  };

     const handleDownloadChart = async () => {
      try {
        // Step 1: Prepare enhanced chart options for export
        const pdfChartOptions = {
          ...chartOptions,
          width: 1800, // use full width for better readability
          height: 950,
          chartArea: {
            left: 80,
            top: 140, // more space for legend above
            bottom: 160,
            width: "100%",
            height: "100%",
          },
          hAxis: {
            ...chartOptions.hAxis,
            slantedText: true,
            slantedTextAngle: 45,
            textStyle: { fontSize: 16, color: "#333" },
          },
          vAxis: {
            ...chartOptions.vAxis,
            textStyle: { fontSize: 15, color: "#333" },
          },
          annotations: {
            ...chartOptions.annotations,
            textStyle: { fontSize: 15, bold: true, color: "#000" },
          },
          colors: colorData, // Use same colors as legend
        };
  
        // Step 2: Create hidden container
        const hiddenContainer = document.createElement("div");
        hiddenContainer.id = "pdf-temp-chart";
        hiddenContainer.style.position = "absolute";
        hiddenContainer.style.left = "-9999px";
        hiddenContainer.style.top = "0";
        hiddenContainer.style.width = "1800px";
        hiddenContainer.style.background = "#fff";
        hiddenContainer.style.padding = "20px";
        document.body.appendChild(hiddenContainer);
  
        // Step 3: Build custom legend (larger + full width)
        const legendDiv = document.createElement("div");
        legendDiv.style.display = "flex";
        legendDiv.style.flexWrap = "wrap";
        legendDiv.style.justifyContent = "space-evenly"; // evenly spaced full width
        legendDiv.style.marginBottom = "20px";
        legendDiv.style.fontFamily = "Arial, sans-serif";
        legendDiv.style.width = "100%";
  
        chartData.slice(1).forEach((label, index) => {
          const item = document.createElement("div");
          item.style.display = "flex";
          item.style.alignItems = "center";
          item.style.margin = "8px 16px";
          item.style.fontSize = "18px"; // larger font
          item.style.fontWeight = "bold";
          item.style.whiteSpace = "nowrap";
  
          const colorBox = document.createElement("div");
          colorBox.style.width = "18px";
          colorBox.style.height = "18px";
          colorBox.style.backgroundColor = colorData[index];
          colorBox.style.marginRight = "8px";
          colorBox.style.border = "1px solid #aaa";
          colorBox.style.borderRadius = "3px";
  
          const textNode = document.createTextNode(
            `${label[0]} (${label[1]})`
          );
  
          item.appendChild(colorBox);
          item.appendChild(textNode);
          legendDiv.appendChild(item);
        });
  
        hiddenContainer.appendChild(legendDiv);
  
        // Step 4: Add chart container
        const chartDiv = document.createElement("div");
        chartDiv.style.width = "1800px";
        chartDiv.style.height = "900px";
        hiddenContainer.appendChild(chartDiv);
  
        // Step 5: Draw chart
        const tempChart = new window.google.visualization.ColumnChart(chartDiv);
        const dataTable = window.google.visualization.arrayToDataTable(chartData);
        await new Promise((resolve) => {
          window.google.visualization.events.addListener(tempChart, "ready", resolve);
          tempChart.draw(dataTable, pdfChartOptions);
        });
  
        // Step 6: Capture legend + chart together
        const canvas = await html2canvas(hiddenContainer, {
          useCORS: true,
          scale: 2.8,
          logging: false,
        });
        const imgData = canvas.toDataURL("image/png");
  
        // Step 7: Clean up
        document.body.removeChild(hiddenContainer);
  
        // Step 8: Create PDF
        const pdf = new jsPDF({
          orientation: "landscape",
          unit: "mm",
          format: "a4",
        });
  
        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();
        const margin = 5;
        const headerHeight = 14;
        const footerHeight = 10;
        const infoBlockHeight = 15;
        const availableHeight =
          pageHeight - headerHeight - footerHeight - infoBlockHeight - 6;
  
        // Header
        pdf.setFillColor(31, 38, 62);
        pdf.rect(0, 0, pageWidth, headerHeight, "F");
        try {
          pdf.addImage(logoImg, "PNG", margin, 4, 40, 10);
        } catch { }
  
        pdf.setFont("helvetica", "bold");
        pdf.setFontSize(14);
        pdf.setTextColor(255, 255, 255);
        pdf.text("DIAMOND CUT SEARCH REPORT", pageWidth - margin, 11, {
          align: "right",
        });
  
        // Info line
         pdf.setFont("helvetica", "normal");
      pdf.setFontSize(9);
      pdf.setTextColor(0, 0, 0);

      const preparedFor =
        loginDetials?.impresonateData
          ? `Prepared For: ${loginDetials.impresonateData.username} (${loginDetials.impresonateData.dealerID})`
          : loginDetials?.loginDetials?.responseData
            ? `Prepared For: ${loginDetials.loginDetials.responseData.dealerCompany} (${loginDetials.loginDetials.responseData.dealerId})`
            : "Prepared For: -";

      const dateRange = `Date Range: ${moment(globalDiamonds.dataRangeFrom).format(
        "MMM DD, YYYY"
      )} - ${moment(globalDiamonds.dataRangeTo).format("MMM DD, YYYY")}`;

      const selectedDiamondLabel =
        globalDiamonds.SelectedDiamondValue === "All"
          ? "All Diamonds"
          : globalDiamonds.SelectedDiamondValue === "Mined"
            ? "Mined Diamonds"
            : "Lab Grown Diamonds";

      const diamondType = `Selected Diamond: ${selectedDiamondLabel}`;
      const clicks = `Total Clicks: ${TotalDiamondClicks?.toLocaleString() || 0}`;

      const infoLinesRaw = [
        preparedFor,
        dateRange,
        diamondType,
        clicks
      ].filter(Boolean);

      const maxWidth = pageWidth - margin * 2;

      // Split text dynamically to fit within the maxWidth
      const wrappedInfoLines = infoLinesRaw.flatMap((line) =>
        pdf.splitTextToSize(line, maxWidth)
      );

      const lineHeight = 4.8;
      let currentY = headerHeight + 5;

      // Display each line with proper spacing
      wrappedInfoLines.forEach((line) => {
        pdf.text(line, margin, currentY);
        currentY += lineHeight;
      });

      currentY += 4;
  
        // Chart + Legend image
        const imgRatio = canvas.width / canvas.height;
        let imgWidthMM = pageWidth - margin * 3;
        let imgHeightMM = imgWidthMM / imgRatio;
        if (imgHeightMM > availableHeight) {
          imgHeightMM = availableHeight;
          imgWidthMM = imgHeightMM * imgRatio;
        }
  
        const xPos = margin;
        const yPos = currentY; 
        pdf.addImage(imgData, "PNG", xPos, yPos, imgWidthMM, imgHeightMM, undefined, "FAST");
  
        // Footer
        pdf.setFillColor(31, 38, 62);
        pdf.rect(0, pageHeight - footerHeight, pageWidth, footerHeight, "F");
        pdf.setTextColor(255, 255, 255);
        pdf.setFont("helvetica", "italic");
        pdf.setFontSize(8);
        const footerText = `© ${new Date().getFullYear()} JewelCloud Inc. | Generated on ${moment().format(
          "MMM DD, YYYY h:mm A"
        )}`;
        pdf.text(footerText, pageWidth / 2, pageHeight - footerHeight / 2 + 2, {
          align: "center",
        });
  
        // --- WATERMARK ---
          const watermarkText = "JewelCloud";
          pdf.setFontSize(90);
          pdf.setFont(undefined, "bolditalic");
          pdf.setTextColor(102, 102, 102);
  
          pdf.saveGraphicsState();
          pdf.setGState(pdf.GState({ opacity: 0.1 }));
  
          const centerX = pageWidth / 2;
          const centerY = pageHeight / 2;
  
          const textWidth = pdf.getTextWidth(watermarkText);
          const textHeight =
            pdf.internal.getFontSize() / pdf.internal.scaleFactor;
  
          const angleRad = (45 * Math.PI) / 180;
          const rotatedWidth =
            textWidth * Math.cos(angleRad) + textHeight * Math.sin(angleRad);
          const rotatedHeight =
            textWidth * Math.sin(angleRad) + textHeight * Math.cos(angleRad);
  
          const xPosWatermark = centerX - rotatedWidth / 2;
          const yPosWatermark = centerY + rotatedHeight / 4 + 40;
  
          pdf.text(watermarkText, xPosWatermark, yPosWatermark, { angle: 45 });
  
          pdf.restoreGraphicsState();
  
        pdf.save("Diamond-Cut-Search-Report.pdf");
      } catch (err) {
        console.error("Error generating PDF:", err);
      }
    };

  return (
    <React.Fragment>
      <div className="form__fields magento__mapping">
        <div className="row">
          <div className="col-lg-12">
            <div className="heading__block">
              <h4 class="workarea__heading mt-0 mb-0">
                {t("Diamond CutGrade Searches")}
              </h4>
            </div>
          </div>
          <div className="col-md-4">
            <div className="input__block dataRange-input-block datepicker__block">
              <label> {t("Date Range")} </label>
              <RangePicker
                className="date-range-input"
                ranges={{
                  Today: [moment(), moment()],
                  Yesterday: [
                    moment().subtract(1, "days"),
                    moment().subtract(1, "days"),
                  ],
                  "Last 7 Days": [moment().subtract(7, "days"), moment()],
                  "Last 30 Days": [moment().subtract(30, "days"), moment()],
                  "This Month": [
                    moment().startOf("month"),
                    moment().endOf("month"),
                  ],
                  "Last Month": [
                    moment().subtract(1, "month").startOf("month"),
                    moment().subtract(1, "months").endOf("month"),
                  ],
                  "Last 90 Days": [moment().subtract(90, "days"), moment()],
                  "Year To Date": [moment().startOf("year"), moment()],
                }}
                format={"MM-DD-YYYY"}
                onChange={onDateChange}
                defaultValue={[moment().subtract(30, "days"), moment()]}
                defaultPickerValue={[moment().subtract(30, "days"), moment()]}
              />
            </div>
          </div>
          <div className="col-md-4">
            <div className="input__block">
              <label> {t("Select Diamond")} </label>
              <Select
                className="border__grey"
                placeholder={t("All")}
                showSearch
                name="SelectedDiamondValue"
                optionFilterProp="children"
                value={
                  globalDiamonds.SelectedDiamondValue
                    ? globalDiamonds.SelectedDiamondValue
                    : null
                }
                onChange={(e) =>
                  handleOnChange(e, "select", "SelectedDiamondValue")
                }
              >
                <Option value="All">{t("All")}</Option>
                <Option value="Mined">{t("Mined Diamond")}</Option>
                <Option value="Lab">{t("Lab Grown Diamond")}</Option>
              </Select>
            </div>
          </div>

          {chartData.length > 1 && TableForAllList && TableForAllList.length > 0 && (
            <div className="col-lg-12 col-md-6 mt-4">
              <div className="input__block">
                <label>
                  <Spin spinning={LoadChartReportsLoading} size="small">
                    <b>
                      {" "}
                      {t("Total Clicks")} :{" "}
                      {TotalDiamondClicks ? TotalDiamondClicks : 0}
                    </b>
                  </Spin>
                </label>
              </div>
            </div>
          )}

          <div className="col-md-12 mt-2">
            <div className="button__block mb-4">
              <button className="primary-btn mr-2" onClick={handleApplyFilter}>
                {" "}
                {t("Apply Filter")}{" "}
              </button>
            </div>
          </div>

          <div className="chart__section">
            <Spin spinning={LoadChartReportsLoading} size="large">
              {chartData.length > 1 && TableForAllList && TableForAllList.length > 0 ? (
                <div id="pdf-content">
                  {/* Custom Legend for Bar Chart */}
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      justifyContent: "center",
                      marginBottom: "10px",
                    }}
                  >
                    {chartData.slice(1).map((row, index) => (
                      <div
                        key={index}
                        style={{
                            display: "flex",
                          alignItems: "center",
                          margin: "4px 8px",
                          fontSize: "13px",
                          fontWeight: "500",
                        }}
                      >
                        <div
                          style={{
                             width: "14px",
                            height: "14px",
                            backgroundColor: colorData[index],
                            marginRight: "6px",
                            borderRadius: "3px",
                          }}
                        ></div>
                        {row[0]} ({row[1]})
                      </div>
                    ))}
                  </div>

   <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      width: "100%",

                    }}
                  >
                  {/* Bar Chart */}
                  <Chart
                    chartType="ColumnChart"
                    width={window.innerWidth > 500 ? "100%" : 300}
                    height={window.innerWidth > 500 ? 750 : 300}
                    data={chartData}
                    options={{...chartOptions, colors: colorData}}
                    chartEvents={[
                      {
                        eventName: "select",
                        callback: handleClick,
                      },
                    ]}
                  />
                  </div>
                </div>
              ) : (
                <div className="no-report-render">
                  <div className="desc-space">
                    <h4 className="text-center">{t("No Data Found")}</h4>
                  </div>
                </div>
              )}
            </Spin>
          </div>

          <div className="col-lg-12 mt-3 d-flex flex-column flex-lg-row justify-content-lg-end mb-3">
            {chartData.length > 1 && (
              <Button className="primary-btn mb-2 mb-lg-0 mr-2" onClick={handleDownloadChart}>
                {" "}
                <i className="fa fa-download"></i> {t("Download Chart")}
              </Button>
            )}
            <Button
              className="primary-btn mb-2 mb-lg-0 mr-2"
              onClick={() => handleExportToPDF()}
              loading={downloadPDFDataloading}
            >
              <i className="fa fa-download"></i> {t("Download PDF")}
            </Button>
            <Button
              className="primary-btn"
              onClick={() => handleExportToCSV()}
              loading={downloadCSVDataloading}
            >
              <i className="fa fa-download"></i> {t("Download CSV")}
            </Button>
          </div>

          <div className="col-lg-12 col-md-12">
            <Table
              key={tableKey}
              className="pendjewelreq__tbl"
                scroll={{ y: "calc(100vh - 340px)" }}
              loading={TableForAllLoading}
              columns={[
                {
                  title: (
                    <Tooltip title={t("UserIPAddress")}>
                      {t("UserIPAddress")}
                    </Tooltip>
                  ),
                  ellipsis: true,
                  dataIndex: "usersIPAddress",
                  sorter: (a, b) => {},
                },
                {
                  title: <Tooltip title={t("Date")}>{t("Date")}</Tooltip>,
                  ellipsis: true,
                  dataIndex: "date",
                  key: "GT.MODIFIED",
                  defaultSortOrder: "descend",
                  sorter: (a, b) => {},
                  render: (item, row) => {
                    return moment(row.date).format("MM-DD-YYYY, hh:mm:ss A");
                  },
                },
                {
                  title: <Tooltip title={t("Shape")}>{t("Shape")}</Tooltip>,
                  ellipsis: true,
                  dataIndex: "shape",
                  sorter: (a, b) => {},
                },
                {
                  title: <Tooltip title={t("Size")}>{t("Size")}</Tooltip>,
                  ellipsis: true,
                  dataIndex: "size",
                  sorter: (a, b) => {},
                },
                {
                  title: <Tooltip title={t("Color")}>{t("Color")}</Tooltip>,
                  ellipsis: true,
                  dataIndex: "color",
                  sorter: (a, b) => {},
                },
                {
                  title: <Tooltip title={t("Cut")}>{t("Cut")}</Tooltip>,
                  ellipsis: true,
                  dataIndex: "cutGrade",
                  sorter: (a, b) => {},
                },
                {
                  title: <Tooltip title={t("Clarity")}>{t("Clarity")}</Tooltip>,
                  ellipsis: true,
                  dataIndex: "clarity",
                  sorter: (a, b) => {},
                  render: (row, item) => {
                    if (item.clarity) {
                      return (
                        <React.Fragment>
                          <span>{item.clarity}</span>
                        </React.Fragment>
                      );
                    }
                  },
                },
                {
                  title: (
                    <Tooltip title={t("Certificate")}>
                      {t("Certificate")}
                    </Tooltip>
                  ),
                  ellipsis: true,
                  dataIndex: "certificate",
                  sorter: (a, b) => {},
                },
                {
                  title: (
                    <Tooltip title={t("RetailerPrice")}>
                      {t("RetailerPrice")}
                    </Tooltip>
                  ),
                  ellipsis: true,
                  dataIndex: "retailPrice",
                  sorter: (a, b) => {},
                  render: (row, item) => {
                    return (
                      <React.Fragment>
                        <span>
                          {item.retailPrice ? (
                            <span>
                              {/* {loginDetials.currency ? "" : "$"} */}
                              {item.retailPrice}
                            </span>
                          ) : (
                            "Call For Price"
                          )}
                        </span>
                      </React.Fragment>
                    );
                  },
                },
                {
                  title: <Tooltip title={t("Cost")}>{t("Cost")}</Tooltip>,
                  ellipsis: true,
                  dataIndex: "cost",
                  sorter: (a, b) => {},
                  render: (row, item) => {
                    return (
                      <React.Fragment>
                        <span>
                          {item.cost ? (
                            <span>
                              {/* {loginDetials.currency ? "" : "$"} */}
                              {item.cost}
                            </span>
                          ) : (
                            "Call For Price"
                          )}
                        </span>
                      </React.Fragment>
                    );
                  },
                },
              ]}
              dataSource={TableForAllList}
              pagination={{
                size: "small",
                total: totalCount,
                pageNo: pageNo,
                pageSize: pageSize,
                pageSizeOptions: [10, 15, 20, 50, 100],
                responsive: true,
                showSizeChanger: true,
              }}
              onChange={handleTableASCDES}
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default DiamondCutIndComp;